import React, { useCallback, useState } from "react"

import { Input } from "@coval/ui/input"

interface SipAddressInputProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  className?: string
  error?: string
  hidePlaceholder?: boolean
}

export const SipAddressInput: React.FC<SipAddressInputProps> = ({
  value,
  onChange,
  disabled = false,
  error,
  className = "",
  hidePlaceholder = false,
}) => {
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = useCallback(() => setIsFocused(true), [])
  const handleBlur = useCallback(() => setIsFocused(false), [])

  const showError = !isFocused && value.length > 0 && !!error

  return (
    <div className="w-full">
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder={
          hidePlaceholder ? "Enter a SIP address" : "sip:user@example.com"
        }
        aria-label="SIP Address"
        className={className}
        error={!!showError}
      />
      {showError && (
        <p className="text-xs text-coval-danger-text mt-1">
          Please enter a valid SIP address (e.g. sip:user@example.com)
        </p>
      )}
    </div>
  )
}
